const timeline_data = {
  WinterOlympics: {
    title: "Beijing Winter Olympics",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020004159.jpeg",
    alt: "2022 Beijing Winter Olympics, 2022.1-2022.3",
    context: "2022 Beijing Winter Olympics, 2022.1-2022.3",
    category: "Life & friends",
    time: "January – March 2022",
    link: "",
  },
  FriendRuihua: {
    title: "With Ruihua",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020000127.png",
    alt: "Ruihua Chen(Now Ph.D at THU)",
    context: "Ruihua Chen(Now Ph.D at THU)",
    category: "Life & friends",
    time: "",
    link: "",
  },
  FriendsBUAA: {
    title: "Friends at BUAA",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020002390.jpeg",
    alt: "Alxa Union, my friends at BUAA",
    context: "Alxa Union, my friends at BUAA",
    category: "Life & friends",
    time: "",
    link: "",
  },
  FriendQu: {
    title: "With ZY Qu",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020806412.png",
    alt: "ZY Qu(Now MA. at BUAA)",
    context: "ZY Qu(Now MA. at BUAA)",
    category: "Life & friends",
    time: "",
    link: "",
  },
  FriendsSiaJames: {
    title: "With Sia and James",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020010662.jpeg",
    alt: "Sia Yang(Now MA. at HUST) and James Jian(Now Ph.D at SYSU)",
    context: "Sia Yang(Now MA. at HUST) and James Jian(Now Ph.D at SYSU)",
    category: "Life & friends",
    time: "",
    link: "",
  },
  FriendErenrat: {
    title: "With Erenrat",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311020017110.png",
    alt: "Erenrat Zeng(Now MA. at ANU)",
    context: "Erenrat Zeng(Now MA. at ANU)",
    category: "Life & friends",
    time: "",
    link: "",
  },
  FriendsSingapore: {
    title: "Meeting friends in Singapore",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202506170008560.jpeg",
    alt: "Meeting Songxiao and his friend in Singapore",
    context: "Meeting Songxiao and his friend in Singapore",
    category: "Life & friends",
    time: "",
    link: "",
  },
  Korea_2026: {
    title: "Seoul & Busan, with Songxiao",
    time: "October 2026",
    category: "Travel",
    context: "I travelled to Seoul and Busan with Songxiao.",
    image: "/images/2026/korea.jpg",
    alt: "Sharing a meal with Songxiao during our Korea trip",
    link: "",
  },
  ICML_2026: {
    title: "A summer at ICML",
    time: "July 2026",
    category: "Research",
    context: "I attended ICML 2026.",
    image: "/images/2026/icml.jpg",
    alt: "With friends at ICML 2026",
    link: "",
  },
  Alibaba: {
    title: "A new chapter at Alibaba",
    time: "March 2026",
    category: "Work",
    context:
      "I joined Alibaba as an algorithm engineer, working on Agent Harness.",
    image: "/images/2026/alibaba.jpg",
    imagePosition: "65% center",
    alt: "At an Alibaba welcome event",
    link: "",
  },
  Cambodia: {
    title: "Cambodia with Yufei",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/ca6a8bba2467c7dab9a44919c60784b0.jpg",
    alt: "Cambodia trip with Yufei. A nice place to explore!",
    link: "",
    color: "#032EA1",
    time: "12.24 - 1.3",
    context: "I travelled to Cambodia🇰🇭 with Yufei.",
    logo: "temple",
  },
  Taiwan: {
    title: "Taiwan with Songxiao",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/99c69e67b8e1566e94a2374c60787197.jpg",
    alt: "Visted Taiwan with Songxiao. We travelled around Taiwan island.",
    link: "",
    color: "#E30A17",
    time: "12.24 - 1.3",
    context: "I travelled to Taiwan🌊 with Songxiao.",
    logo: "landscape",
  },
  Egypt: {
    title: "Egypt with friends",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/94f9c227ce198f2830677a06c98e5ace.jpg",
    alt: "Egypt trip with friends.",
    link: "",
    color: "#E30A17",
    time: "12.11 - 12.21",
    context: "I travelled to Egypt🇪🇬 with a group of nice friends.",
    logo: "airport",
  },
  Turkey: {
    title: "T\u00fcrkiye with Xindu",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/d065fa82a3b46c1f4d2bb0be2c601556.jpg",
    alt: "Visted T\u00fcrkiye with Xindu Yu (MA. at NUS)",
    link: "",
    color: "#E30A17",
    time: "12.1 - 12.10",
    context:
      "I travelled to Türkiye🇹🇷 with Xindu Yu, exploring cities in Anatolia.",
    logo: "",
  },
  EMNLP: {
    title: "EMNLP 2025",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/6778bc4b40999eccc90c57234404546c.jpg",
    alt: "EMNLP'25 with Bryan's group, wonderful trip!",
    link: "",
    color: "#0B6623",
    time: "11.3 - 11.10",
    context: "I attended EMNLP'25 conference, Suzhou, China🇨🇳",
    logo: "school",
  },
  Xiaomi: {
    link: "",
    color: "#FF6900",
    time: "5.22 - 9.23",
    context:
      "I did an internship as an algorithm engineer at Xiaomi. I work on Large Language Models.",
    logo: "work",
  },
  Japan_2025: {
    link: "",
    color: "#42A5F5",
    time: "1.12 - 1.18",
    context:
      "I visited Japan🇯🇵 with Songxiao again. This time we travelled in Hokkaido❄️",
    logo: "flight",
  },
  Australia: {
    title: "Australia with Erenrat",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202506162357607.jpeg",
    alt: "An unforgettable journey with Erenrat in Australia!",
    link: "posts/2024/australia",
    color: "#00BCD4",
    time: "12.10 - 12.21",
    context: "I travelled to Australia for holiday.",
    logo: "flight",
  },
  Begin_NUS: {
    link: "",
    color: "#FBC02D",
    time: "8.1",
    context: "I began my study at NUS.",
    logo: "school",
  },
  Japan_2024: {
    title: "Graduation trip to Japan",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202408281605982.png",
    alt: "Visited Japan with Raywha Chen, X. Tuo(Now Ph.D at THU), Q. Zhang(Now MA. at THU), 2024",
    link: "",
    color: "#42A5F5",
    time: "7.2 - 7.9",
    context: "I visited Japan🇯🇵 for a graduation tour.",
    logo: "flight",
  },
  Graduate_BUAA: {
    title: "Graduation",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202408281602813.png",
    alt: "My Graduation, the photo is taken at THU",
    link: "posts/2024/graduate",
    color: "#42A5F5",
    time: "7.1",
    context:
      "I graduated from Beihang University (BUAA)🧑‍🎓 and obtained" +
      " B.E. degree in Computer Science.",
    logo: "school",
  },
  Vietnam: {
    link: "posts/2024/vietnam",
    color: "#66BB6A",
    time: "2.2 - 2.6",
    context: "I visited Ho Chi Minh & Nah Trang, Vietnam🇻🇳【Blog】",
    logo: "flight",
  },
  Malaysia: {
    link: "/posts/2024/malaysia",
    color: "#EF6C00",
    time: "1.3 - 1.6",
    context: "I visited Kota Kinabalu, Malaysia🇲🇾【Blog】",
    logo: "flight",
  },
  NTU: {
    link: "",
    color: "#1664C0",
    time: "2023.12.15 - 2024.2.8",
    context: "I visited NTU in Singapore🇸🇬 for an Internship",
    logo: "science",
  },
  Japan: {
    link: "/posts/2023/japan",
    color: "#6D4C41",
    time: "11.3 - 11.12",
    context: "I visited Japan🇯🇵 With Songxiao【Blog】",
    logo: "flight",
    title: "Japan-2023",
  },
  Yantai: {
    link: "/posts/2023/yantai",
    color: "#2F7D32",
    time: "10.20 - 10.22",
    context: "I visited Yantai City🍎, Shandong【Blog】",
    logo: "flight",
  },
  National: {
    link: "",
    color: "#2F7D32",
    time: "10.1 - 10.9",
    context: "I was at Home🏠 for National Holiday",
    logo: "flight",
  },
  Changsha: {
    link: "",
    color: "#EF6C00",
    time: "9.23 - 9.25",
    context: "I visited Changsha City🌶️, Hunan",
    logo: "flight",
  },
  Xiaan: {
    link: "",
    color: "#EF6C00",
    time: "9.14 - 9.19",
    context: "I visited Shaanxi🍜 and took the GRE test",
    logo: "quiz",
  },
  Month: {
    link: "",
    color: "#FBC02D",
    time: "Whole month",
    context: "I was doing Internship at HKU🧐",
    logo: "science",
  },
  HKU: {
    title: "A summer at HKU",
    image:
      "https://raw.githubusercontent.com/Enqurance/Figures/main/202311012342376.png",
    alt: "HKU, 2023.7-2023.9",
    link: "",
    color: "#7B1EA2",
    time: "7.16 - 9.1",
    context: "I was doing an Internship at HKU🇭🇰",
    logo: "science",
  },
  Changbai: {
    link: "",
    color: "#00BCD4",
    time: "6.26-6.29",
    context: "I visited Mt. Changbai⛰️, Jilin",
    logo: "flight",
  },
  School: {
    link: "",
    color: "#81C784",
    time: "2.10",
    context: "I went back school🏫️ after staying 3 months at home",
    logo: "school",
  },
  Corona: {
    link: "",
    color: "#42A5F5",
    time: "12.20",
    context: "I was infected with CoronaVirus😷",
    logo: "medication",
  },
  Oubao: {
    link: "",
    color: "#42A5F5",
    time: "12.5",
    context: "Oubao🐱 joined my family",
    logo: "pets",
  },
  Pendamic: {
    link: "",
    color: "#2F7D32",
    time: "11.29",
    context: "I went home🏠 from Beihang because of the epidemic🦠",
    logo: "flight",
  },
};

export default timeline_data;
